import React, { PropTypes } from 'react';

import { NitroIcon } from 'nitro-components';

import styled from 'styled-components';
import Filter from '../Filter';

const InputContainer = styled.section`
  padding: 0;
  border: 1px solid ${props => props.theme.color.border};
  background-color: ${props => props.theme.color.white};
`;

const SelectInput = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 16px;
`;

const Input = styled.input`
  padding: 5px 0;
  color: ${props => props.theme.color.secondary};
  font-family: ${props => props.theme.font.bold};
  border: none;
  width: 100%;
  &:focus {
    outline: none;
  }
`;

const InputRight = styled.div`
  width: 30px;
  cursor: pointer;
  text-align: right;
  align-self: center;
`;

const OpenText = ({ filter, action }) => {
  const onChange = event => {
    const value = event.target.value;
    action({
      label: value,
      value
    });
  };

  const handleChange = event => {
    if (action) return action(event.target.value);
    return onChange(event);
  };

  const clear = event => {
    if (action) return action(event.target.value);
    return action({
      label: '',
      value: ''
    });
  };

  return (
    <InputContainer>
      <SelectInput>
        <Input onChange={handleChange} value={filter.value} />
        <InputRight>
          {filter.value && (
            <NitroIcon
              name="close"
              varaint="secondary"
              size={8}
              action={clear}
            />
          )}
        </InputRight>
      </SelectInput>
    </InputContainer>
  );
};

OpenText.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired
};

OpenText.getLabel = Filter.getLabel;

export default OpenText;



// WEBPACK FOOTER //
// ./src/components/filter/filters/open-text/OpenText.js